import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import { Button } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { ButtonGroup } from "@material-ui/core";
import { TimePicker } from "@material-ui/pickers";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox";
import Asignacion from "src/services/asignacion";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DatePicker from "src/components/DatePicker";
import { IonAlert } from "@ionic/react";
import { Dialog, DialogContent } from '@material-ui/core';


// Formatea un numero/string a separador de miles con punto (formato Guarani).
// Maneja tanto enteros ("150000") como decimales del backend ("150000.00").
// Trunca la parte decimal porque Guarani no usa centavos.
const formatMiles = (val) => {
  if (val === "" || val === null || val === undefined) return "";
  const num = Math.floor(Number(val));
  if (!Number.isFinite(num) || num < 0) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};



const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "scroll",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  textField: {
    width: 140,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },

}));

export default function TransitionsModal(props) {
  const {onConfirm } = props;
  const classes = useStyles();
  //referencia
  const referancia = useRef(null);

  const [open, setOpen] = React.useState(false);
  //dias
  const [checked, setChecked] = React.useState([]);
  //hora
  const [value, setValue] = useState(new Date());
  const [valor, setValor] = useState(new Date());
  //fecha
  const [Fecha, setFecha] = React.useState(new Date());
  // const [FechaFin, setFechaFin] = React.useState(new Date());
  //operario
  const [searchValue, setSearchValue] = React.useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage , setAlertMessage] = useState('');
  
  //configurar hooks
  const [rows, setRows] = useState([{}]);

  // Beneficios: Tarjeta Gourmet y Viatico Combustible/Pasaje
  const [viaticoGourmet, setViaticoGourmet] = useState(false);
  const [viaticoOperario, setViaticoOperario] = useState(false);
  const [viaticoGourmetMonto, setViaticoGourmetMonto] = useState("");
  const [viaticoOperarioMonto, setViaticoOperarioMonto] = useState("");
  const [gourmetDisponible, setGourmetDisponible] = useState("0");
  const [viaticoDisponible, setViaticoDisponible] = useState("0");

  // Candidatos rankeados por IA (mismo flujo que EMSYS: SP de disponibles + webhook n8n)
  const [candidatos, setCandidatos] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [operarioSeleccionado, setOperarioSeleccionado] = useState("");


  useEffect(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  useEffect(() => {
    if (open) {
      (async () => {
        await loadDisponibilidad();
      })();
    }
  }, [open]);

  const loadData = async () => {
    const url = await Asignacion.listarOperarios();
    const response = url;
    setRows(response);
  };

  const loadDisponibilidad = async () => {
    const ps_id = sessionStorage.getItem("ps_id");
    if (!ps_id) return;
    const disp = await Asignacion.obtenerDisponibilidadBeneficios(ps_id);
    if (disp) {
      setGourmetDisponible(disp.gourmet_disponible || "0");
      setViaticoDisponible(disp.viatico_disponible || "0");
    } else {
      setGourmetDisponible("0");
      setViaticoDisponible("0");
    }
    setViaticoGourmet(false);
    setViaticoOperario(false);
    setViaticoGourmetMonto("");
    setViaticoOperarioMonto("");
    setCandidatos([]);
    setOperarioSeleccionado("");
  };

  const handleBlur = (event) => {
    const targetValue = event.nativeEvent.target.defaultValue;
    setSearchValue(targetValue);
    // Si el fiscal escribe manualmente, descartamos la seleccion del ranking.
    if (targetValue) setOperarioSeleccionado("");
  };

  const onChange = (timeValue) => {
    setValue(timeValue);
  };

  const onChangeSalida = (timeValue) => {
    setValor(timeValue);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Mapeo dia -> campos de entrada/salida que espera el backend.
  const DIA_CAMPOS = {
    LUNES: ["lun_ent", "lun_sal"],
    MARTES: ["mar_ent", "mar_sal"],
    MIERCOLES: ["mie_ent", "mie_sal"],
    JUEVES: ["jue_ent", "jue_sal"],
    VIERNES: ["vie_ent", "vie_sal"],
    SABADO: ["sab_ent", "sab_sal"],
    DOMINGO: ["dom_ent", "dom_sal"],
  };

  // Construye los campos de horario (lun_ent...dom_sal) a partir de los dias
  // tildados y el horario de entrada/salida unico del modal.
  const camposHorario = () => {
    const horaEntrada = value.toISOString().slice(11, 16);
    const horaSalida = valor.toISOString().slice(11, 16);
    const campos = {};
    for (let dia of checked) {
      if (DIA_CAMPOS[dia]) {
        campos[DIA_CAMPOS[dia][0]] = horaEntrada;
        campos[DIA_CAMPOS[dia][1]] = horaSalida;
      }
    }
    return campos;
  };

  // Busca los candidatos disponibles para el horario elegido y los rankea con IA.
  const handleBuscar = async () => {
    const dias = checked.filter((c) => c !== "SUPERVISOR");
    if (dias.length < 1) {
      setAlertMessage("Por favor elije al menos un dia de la semana antes de buscar operarios");
      setShowAlert(true);
      return;
    }
    setBuscando(true);
    const filtros = {
      ps_id: sessionStorage.getItem("ps_id"),
      fecha_inicio: JSON.stringify(Fecha.toJSON()).slice(1, 11),
      supervisor: checked.includes("SUPERVISOR"),
      ...camposHorario(),
    };
    const res = await Asignacion.buscarOperarios(filtros);
    setCandidatos(res || []);
    setBuscando(false);
    if (!res || res.length === 0) {
      setAlertMessage("No se encontraron operarios disponibles para ese horario");
      setShowAlert(true);
    }
  };

  // Selecciona un candidato del ranking y lo deja listo para confirmar.
  const seleccionarCandidato = (cand) => {
    const legajo = cand.nroLegajo || cand.legajo || "";
    const nombre = cand.nombres || cand.nombre || cand.operario || "";
    setSearchValue(`${nombre} - ${legajo}`);
    setOperarioSeleccionado(`${nombre} - ${legajo}`);
  };

  const handleClick = (event) => {
    const datos = {};
    const search = operarioSeleccionado || searchValue;
    const operarios = search;
    const horaEntrada = value.toISOString().slice(11, 16);
    const horaSalida = valor.toISOString().slice(11, 16);
    const FechaInicio = JSON.stringify(Fecha.toJSON()).slice(1, 11);
    // const FechaFinal = JSON.stringify(FechaFin.toJSON()).slice(1,11);
    datos.operario = operarios;
    datos.fecha_inicio = FechaInicio;
    // datos.fecha_fin = FechaFinal;

    // Campos de horario por dia y flag supervisor.
    Object.assign(datos, camposHorario());
    datos.supervisor = checked.includes("SUPERVISOR");

    if (event) {
      if (horaSalida.valueOf() < horaEntrada.valueOf()) {
        alert("Hora de salida es menor a la hora de entrada");
        }
        if (!search){
          alert('Por favor elige un operario')
        }else if(checked.filter((c) => c !== "SUPERVISOR").length < 1){
          setAlertMessage('Por favor elije un dia de la semana')
          setShowAlert(true)
          handleClose()
        }
      else {
        // Validacion de montos de viatico antes de enviar.
        // El estado guarda solo digitos (sin puntos), por lo que parseFloat alcanza.
        const parseMonto = (v) => (v ? parseFloat(String(v).replace(/\D/g, "")) : NaN);
        const dispG = parseFloat(gourmetDisponible) || 0;
        const dispV = parseFloat(viaticoDisponible) || 0;
        let montoG = null;
        let montoV = null;
        if (viaticoGourmet) {
          montoG = parseMonto(viaticoGourmetMonto);
          if (isNaN(montoG) || montoG <= 0) {
            setAlertMessage("Debe ingresar un monto valido para Tarjeta Gourmet");
            setShowAlert(true);
            return;
          }
          if (montoG > dispG) {
            setAlertMessage(`El monto de Tarjeta Gourmet supera el disponible (${formatMiles(dispG)} ₲)`);
            setShowAlert(true);
            return;
          }
        }
        if (viaticoOperario) {
          montoV = parseMonto(viaticoOperarioMonto);
          if (isNaN(montoV) || montoV <= 0) {
            setAlertMessage("Debe ingresar un monto valido para Viatico Combustible/Pasaje");
            setShowAlert(true);
            return;
          }
          if (montoV > dispV) {
            setAlertMessage(`El monto de Viatico Combustible/Pasaje supera el disponible (${formatMiles(dispV)} ₲)`);
            setShowAlert(true);
            return;
          }
        }

        datos.ps_id = sessionStorage.getItem("ps_id");
        datos.viatico_gourmet = viaticoGourmet;
        datos.viatico_operario = viaticoOperario;
        if (viaticoGourmet) datos.viatico_gourmet_monto = montoG;
        if (viaticoOperario) datos.viatico_operario_monto = montoV;
        console.log(datos);
        //envia un jason en base lo que el fiscal elige en el modal
        Asignacion.guardarAsignacion(datos)
          .then((response) => {
            if (response.status === 200) {
              handleClose();
              
              setAlertMessage(response.data.mensaje);
              setShowAlert(true);
              
              onConfirm();
                
            }
          })
          .catch((error) => {
            
              setAlertMessage(error.response.data.error);
              setShowAlert(true);
              
          });
        handleClose();
      }
    }
   
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const dia = [
    "LUNES",
    "MARTES",
    "MIERCOLES",
    "JUEVES",
    "VIERNES",
    "SABADO",
    "DOMINGO",
  ];

  const supervisor = [
    'SUPERVISOR'
  ]

  return (
  <>
      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        message={alertMessage}
        buttons={["cerrar"]}
      />
      <Button
        className="mt-1 mb-1"
        style={{ color: "white" }}
        onClick={handleOpen}
      >
        + ASIGNACION
      </Button>

      <Dialog open={open} onClose={console.log('close')} scroll="paper">
        <DialogContent dividers style={{ padding: '8px', maxWidth: '100%' }}>
              <Autocomplete
                freeSolo
                id="solo"
                ref={referancia}
                onBlur={handleBlur}
                disableClearable
                options={rows.map(
                  (datos) => `${datos.nombre} - ${datos.legajo}`
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    value={searchValue}
                    label="Buscar Operario"
                    variant="outlined"
                    InputProps={{ ...params.InputProps, type: "search" }}
                  />
                )}
              />

                <TimePicker
                  display="default"
                  is24Hour={true}
                  mode="time"
                  label="ENTRADA"
                  onChange={onChange}
                  value={value}
                />
                <TimePicker
                  display="default"
                  is24Hour={true}
                  mode="time"
                  label="SALIDA"
                  onChange={onChangeSalida}
                  value={valor}
                />
               
             
              <div>
                <DatePicker
                  className="half"
                  value={Fecha}
                  placeholder="Fecha Inicio"
                  setValue={setFecha}
                />
                {/* <DatePicker className="half" value={FechaFin} placeholder='Fecha Fin' setValue={setFechaFin}/> */}
              </div>
           
              <h2 id="transition-modal-title" style={{ color: "black" }}>
                Seleccione los dias
              </h2>

              <List dense className={classes.root}>
                {dia.map((value) => {
                  const labelId = `checkbox-list-secondary-label-${value}`;
                  if (`${value}` === dia) {
                    return dia.indexOf(dia);
                  }
                  return (
                    <ListItem key={value} button>
                      <ListItemText id={labelId} primary={`${value}`} />
                      <ListItemSecondaryAction>
                        <Checkbox
                          edge="end"
                          onChange={handleToggle(value)}
                          checked={checked.indexOf(value) !== -1}
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>

              <h5 id="transition-modal-title" style={{ color: "black" }}>
                ¿Es supervisor?
              </h5>

              <List dense className={classes.root}>
                {supervisor.map((value) => {
                  const labelId = `checkbox-list-secondary-label-${value}`;
                  if (`${value}` === supervisor) {
                    return supervisor.indexOf(supervisor);
                  }
                  return (
                    <ListItem key={value} button>
                      <ListItemText id={labelId} primary={`${value}`} />
                      <ListItemSecondaryAction>
                        <Checkbox
                          edge="end"
                          onChange={handleToggle(value)}
                          checked={checked.indexOf(value) !== -1}
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>

              <div style={{ textAlign: "center", margin: "8px 0" }}>
                <Button
                  variant="contained"
                  disabled={buscando}
                  onClick={handleBuscar}
                  style={{ background: "#910434", color: "white", borderRadius: "3px" }}
                >
                  {buscando ? "BUSCANDO..." : "BUSCAR OPERARIOS"}
                </Button>
              </div>

              {candidatos.length > 0 && (
                <>
                  <h5 id="transition-modal-title" style={{ color: "black" }}>
                    Operarios sugeridos (ranking IA)
                  </h5>
                  <List dense className={classes.root}>
                    {candidatos.map((cand, idx) => {
                      const legajo = cand.nroLegajo || cand.legajo || "";
                      const nombre = cand.nombres || cand.nombre || cand.operario || "";
                      const etiqueta = `${nombre} - ${legajo}`;
                      const sel = operarioSeleccionado === etiqueta;
                      const score = cand.score_ia;
                      const dist = cand.distancia_km_dinamica;
                      const horas = cand.horas_total_asignadas;
                      const detalle = [
                        cand.perfil ? `Perfil: ${cand.perfil}` : null,
                        dist != null ? `Dist: ${Number(dist).toFixed(1)} km` : null,
                        horas != null ? `Horas asign.: ${horas}` : null,
                        cand.tiene_movilidad ? "Con movilidad" : null,
                        cand.justificacion ? `— ${cand.justificacion}` : null,
                      ]
                        .filter(Boolean)
                        .join("  •  ");
                      return (
                        <ListItem
                          key={`${legajo}-${idx}`}
                          button
                          selected={sel}
                          onClick={() => seleccionarCandidato(cand)}
                          style={sel ? { border: "2px solid #910434", borderRadius: "4px" } : {}}
                        >
                          <ListItemText
                            primary={`${etiqueta}${score != null ? `   ·   IA: ${score}` : ""}`}
                            secondary={detalle}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </>
              )}

              <List dense className={classes.root}>
                <ListItem button>
                  <ListItemText
                    primary="Tarjeta Gourmet"
                    secondary={`Disp: ${formatMiles(gourmetDisponible)} ₲`}
                  />
                  <ListItemSecondaryAction>
                    <Checkbox
                      edge="end"
                      checked={viaticoGourmet}
                      onChange={(e) => {
                        setViaticoGourmet(e.target.checked);
                        if (!e.target.checked) setViaticoGourmetMonto("");
                      }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                {viaticoGourmet && (
                  <ListItem>
                    <TextField
                      type="text"
                      inputMode="numeric"
                      label="Monto Gourmet"
                      value={formatMiles(viaticoGourmetMonto)}
                      onChange={(e) => setViaticoGourmetMonto(e.target.value.replace(/\D/g, ""))}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">₲</InputAdornment>,
                      }}
                      fullWidth
                    />
                  </ListItem>
                )}

                <ListItem button>
                  <ListItemText
                    primary="Viatico Combustible/Pasaje"
                    secondary={`Disp: ${formatMiles(viaticoDisponible)} ₲`}
                  />
                  <ListItemSecondaryAction>
                    <Checkbox
                      edge="end"
                      checked={viaticoOperario}
                      onChange={(e) => {
                        setViaticoOperario(e.target.checked);
                        if (!e.target.checked) setViaticoOperarioMonto("");
                      }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                {viaticoOperario && (
                  <ListItem>
                    <TextField
                      type="text"
                      inputMode="numeric"
                      label="Monto Viatico"
                      value={formatMiles(viaticoOperarioMonto)}
                      onChange={(e) => setViaticoOperarioMonto(e.target.value.replace(/\D/g, ""))}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">₲</InputAdornment>,
                      }}
                      fullWidth
                    />
                  </ListItem>
                )}
              </List>

            <div>
              <ButtonGroup
                variant="contained"
                style={{ display: "flex" }}
                color="primary"
                aria-label="contained primary button group"
              >
                <Button
                  className="mt-1 mb-1"
                  style={{
                    left: "15px",
                    background: "#910434",
                    color: "white",
                    borderRadius: "3px",
                  }}
                  onClick={handleClick}
                  
                >
                  CONFIRMAR
                </Button>
                <Button
                  className="mt-1 mb-1"
                  onClick={handleClose}
                  style={{
                    left: "30px",
                    background: "#910434",
                    color: "white",
                    borderRadius: "3px",
                  }}
                >
                  CANCELAR
                </Button>
              </ButtonGroup>
            </div>
       
       </DialogContent>
      </Dialog>
  
  </>
  );
}
